import React from "react";
import { Input, Row, Col, Space, Image, Tooltip } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";

import VehicleTempSensorStore from "../store/VehicleTempSensorStore";
import withRouter from "../withRouter";

import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class VehicleTempSensorList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.tempSensorStore = new VehicleTempSensorStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      searchField: "",
      loadData: 0,
    };

    this.columns = [
      {
        // title: " Vehicle No",
        title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
        dataIndex: "vehicleNo",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (vehicleNo) => (
          <Tooltip placement="topLeft" title={vehicleNo}>
            {vehicleNo}
          </Tooltip>
        ),
      },
      {
        // title: "°C Sensor1 Name",
        title: context.translate("_SENSOR1_NAME_"),
        dataIndex: "sensor1Name",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: " °C Sensor1 Low Limit ",
        title: context.translate("_SENSOR1_LOW_LIMIT_"),
        dataIndex: " sensor1LowLimit ",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "°C Sensor1 High Limit ",
        title: context.translate("_SENSOR1_HIGH_LIMIT_"),
        dataIndex: "sensor1HighLimit",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "°C Sensor2 Name",
        title: context.translate("_SENSOR2_NAME_"),
        dataIndex: "sensor2Name",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "°C Sensor2 Low Limit ",
        title: context.translate("_SENSOR2_LOW_LIMIT_"),
        dataIndex: "sensor2LowLimit",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "°C Sensor2 High Limit ",
        title: context.translate("_SENSOR2_HIGH_LIMIT_"),
        dataIndex: "sensor2HighLimit",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "°C Sensor3 Name",
        title: context.translate("_SENSOR3_NAME_"),
        dataIndex: "sensor3Name",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "°C Sensor3 Low Limit ",
        title: context.translate("_SENSOR3_LOW_LIMIT_"),
        dataIndex: " sensor3LowLimit ",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "°C Sensor3 High Limit ",
        title: context.translate("_SENSOR3_HIGH_LIMIT_"),
        dataIndex: "sensor3HighLimit",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
    ];
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    // await this.tempSensorStore.loadData({ offset: 0, limit: 50 });

    this.setState({ pageSize: 50 });
  }
  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.tempSensorStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.tempSensorStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        searchField: "",
      });
    }
    this.setState({ loading: false, searchField: "", currentPage: 1 });
  };

  searchInput = async (e) => {
    const value = e.target.value;

    if (value.length >= 2) {
      await this.tempSensorStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1 });
    } else if (value.length === 0) {
      await this.tempSensorStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1, currentPage: 1 });
    }
  };

  async inputSearchButton() {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      await this.tempSensorStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
        companyId: this.state.companyId,
      });

      await this.setState({ loadList: 1 });
    }
  }

  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "200px", borderRadius: "8px" }
      : { width: "200px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  style={companyInputBox}
                />
                <Input
                  style={{ width: 300, borderRadius: "25px" }}
                  placeholder={this.context.translate("_SEARCH_BY_VEHICLE_NO_")}
                  onChange={async (e) => {
                    this.setState({ searchField: e.target.value });
                    await this.searchInput(e);
                  }}
                  value={this.state.searchField ? this.state.searchField : ""}
                />
                {/* <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={async (e) => {
                    console.log("sdsss", e);
                    await this.inputSearchButton();
                  }}
                /> */}
              </Space>
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                placement="bottom"
                title={this.context.translate("_REFRESH_")}
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            total={this.tempSensorStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.tempSensorStore?.tempSensorVehicles}
            loading={this.tempSensorStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>
      </>
    );
  }
}
VehicleTempSensorList.contextType = StoreContext;
export default observer(withRouter(VehicleTempSensorList));
